export const OPTIONS = {
	text: 'MOHOLY130',
	step: 6,
	sizeFactor: 0.2,
	startYFactor: 0.32,
	bottomPadFactor: 0.22,
	maxLayers: 160,
	opacityMin: 0.01,
	opacityMax: 0.6,
	jitterMax: 8,
	stepJitter: 48,

	// parent drift
	parentNoiseFreq: 0.0016,
	parentAmpX: 24, // px
	parentAmpY: 8, // small vertical wobble

	// per-child extra smear (relative to parent)
	childExtraAmpX: 10, // px

	// NEW: global fade-out window in normalized scroll [0,1]
	fadeOutStart: 0,
	fadeOutEnd: 0.8,

	fontPxBreakpoints: [
		{ max: 600, px: 32 },
		{ max: 900, px: 56 },
		{ max: 1200, px: 64 },
		{ max: 1600, px: 72 },
		{ max: Infinity, px: 96 }
	],
	dpr: 1,
	fontFamily: 'mohol'
};
